import { type RectangularHole } from 'metalworks-domain'

import { GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { GenericDistancePropertyPage } from './GenericDistancePropertyPage'

interface Props {
  id: RectangularHole['id']
}

export const RectangularHolePropertyPage = (props: Props) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyPage id={id} />
      <PropertyContainer.Item title="Width">
        <GenericDimensionInput entityId={id} instanceName="width" />
      </PropertyContainer.Item>
      <PropertyContainer.Item title="Height">
        <GenericDimensionInput entityId={id} instanceName="height" />
      </PropertyContainer.Item>
      <PropertyContainer.Item title="Corner Radius">
        <GenericDimensionInput entityId={id} instanceName="cornerRadius" />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
